module.exports = __webpack_public_path__ + "static/media/websitelogo.80087b01.png";